import { gql } from "@stadium/services/apollo-client";

export const CONTACT_PROVIDER_DETAILS = gql`
  fragment ContactProviderDetails on ContactProvider {
    id: uuid
    category
    providerName
    lastSyncCompletedAt
    uuid
    syncing
    providerSlug
    nickname
    contactsCount
    currencyCode
    sendNotifications
  }
`;
